import React from 'react';

import { SurveyButton } from '../Survey/SurveyButton';

type OnboardingNavProps = {
  onClick: () => void;
};

export const OnboardingNav: React.FC<OnboardingNavProps> = ({ onClick }) => {
  return (
    <div className="onboarding-nav">
      <SurveyButton className="start-over" onClick={onClick}>
        <div className="arrow" />
        Start Over
      </SurveyButton>
    </div>
  );
};
